import {
  browserLocalPersistence,
  browserSessionPersistence,
  getIdTokenResult,
  setPersistence,
  signInWithEmailAndPassword,
  signOut,
} from 'firebase/auth';

export const getAuthorizedAdminEmails = () => {
  const rawValue = (process.env.REACT_APP_ADMIN_EMAILS || '').trim();
  if (!rawValue) return [];
  return rawValue.split(',').map((value) => value.trim().toLowerCase()).filter(Boolean);
};

export const hasAdminClaim = async (user, forceRefresh = false) => {
  if (!user) return false;

  const tokenResult = await getIdTokenResult(user, forceRefresh);
  return tokenResult?.claims?.admin === true;
};

export const isAuthorizedAdminUser = async (user, forceRefresh = false) => {
  if (!user?.email) return false;

  const hasClaim = await hasAdminClaim(user, forceRefresh);
  if (!hasClaim) return false;

  const authorizedEmails = getAuthorizedAdminEmails();
  if (authorizedEmails.length === 0) return true;

  return authorizedEmails.includes(user.email.toLowerCase());
};

export const signInAdmin = async (auth, email, password, remember = true) => {
  await setPersistence(auth, remember ? browserLocalPersistence : browserSessionPersistence);
  const result = await signInWithEmailAndPassword(auth, email, password);
  if (!(await isAuthorizedAdminUser(result.user, true))) {
    await signOut(auth);
    throw new Error('not authorized');
  }
  return result.user;
};

export const signOutAdmin = async (auth) => {
  await signOut(auth);
};
